import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';






@autobind
class ExplorePage extends React.Component {
  state = {

  }

  



  render() {
      var users = this.props.entries.edges;


      var users1 = [];
      var users2 = [];
      for(var i=0; i<users.length;i++){
        if(i%2 === 0){
          users1.push(users[i]);
        } else {
          users2.push(users[i]);
        }
      }
      return (
      <React.Fragment>
        <div className={css(styles.section)}>
          <div className={css(styles.section11)}>
            <div className={css(styles.h4Wrapper)}>
              <h4 className={css(styles.subtitle2)}>EXPLORE</h4>
            </div>
            <h3>Explore and discover other creatives using minimaa.</h3>
            <div className={css(styles.buttonWrapper)}>
              <div onClick={this.getStarted} className={css(styles.button)}>
                TRY FOR FREE
              </div>
            </div>
          </div>
          <div className={css(styles.section12explore)}>
            <div className={css(styles.exploreRow1)}>
              {users1.map((user, i) => {
                var linkToInstagram;
                for(var j=0; j<user.socials.length; j++){
                  if(user.socials[j].type === "instagram"){
                    linkToInstagram = user.socials[j].link;
                  } 
                }
                var minimaaLinkInBio = -1;
                if(user.instagram_user){
                  if(user.instagram_user.website){
                    minimaaLinkInBio = user.instagram_user.website.search("minimaa");
                  }
                }
                var avgLikes = 0;
                var avgComments = 0;
                var usingHashtags = 0;
                var usingLocation = 0;
                var usingFilters = 0;
                var taggingUsers = 0;

                if(user.media){
                  if(user.media.data){
                    for(i=0; i<user.media.data.length; i++){
                      avgLikes = avgLikes+user.media.data[i].likes.count;
                      avgComments = avgComments+user.media.data[i].comments.count;
                      if(user.media.data[i].tags.length > 0){
                        usingHashtags++;
                      }
                      if(user.media.data[i].location){
                        usingLocation++;
                      }
                      if(user.media.data[i].filter !== "Normal"){
                        usingFilters++;
                      }
                      if(user.media.data[i].users_in_photo.length > 0){
                        taggingUsers++;
                      }
                    }
                    avgLikes = Math.round(avgLikes/user.media.data.length);
                    avgComments = Math.round(avgComments/user.media.data.length);
                    usingHashtags = Math.round(usingHashtags*100/user.media.data.length);
                    usingLocation = Math.round(usingLocation*100/user.media.data.length);
                    usingFilters = Math.round(usingFilters*100/user.media.data.length);
                    taggingUsers = Math.round(taggingUsers*100/user.media.data.length);
                  }
                }
                
                return (
                  <div key={user.id} className={css(styles.exploreWrapper)}>
                    {user.instagram_user ?
                      <h4 className={css(styles.red)}>{user.website_title}</h4>
                      :
                      <h4 >{user.website_title}</h4>
                    }
                    <div className={css(styles.exploreInnerWrapper)}>
                      <img className={css(styles.exploreImg)} alt="" src={user.profile_picture}/>
                      <div className={css(styles.explereOverlay)}>
                        <p>{user.description}</p>
                        <a rel="noopener noreferrer" target="_blank" href={"https://"+user.subdomain+".minimaa.co"} className={css(styles.button5)}>
                          VISIT WEBSITE
                        </a>
                        <a rel="noopener noreferrer" target="_blank" href={linkToInstagram}>
                          <img alt="instagram" className={css(styles.explereOverlayInstagram)}src="../../assets/instagram.png" />
                        </a>
                      </div>
                    </div>
                    {user.instagram_user ?
                      <div className={css(styles.infoBox)}>
                        <div>Categories({user.hashtags.length}):</div>
                        <div>Links({user.socials.length}):</div>
                        <div>Minimaa link in bio: {minimaaLinkInBio === -1 ? "NO" : "YES"}</div>
                        <div>Avarage likes per post: {avgLikes}</div>
                        <div>Avarage comments per post: {avgComments}</div>
                        {user.instagram_user && <div>media: {user.instagram_user.counts.media}</div>}
                        {user.instagram_user && <div>followers: {user.instagram_user.counts.followed_by}</div>}
                        {user.instagram_user && <div>following: {user.instagram_user.counts.follows}</div>}
                        <div>usingHashtags: {usingHashtags}% of posts</div>
                        <div>usingLocation: {usingLocation}% of posts</div>
                        <div>usingFilters: {usingFilters}% of posts</div>
                        <div>taggingUsers: {taggingUsers}% of posts</div>
                      </div>
                      :
                      <div className={css(styles.infoBox)}>
                        <div>DON'T HAVE ACCESS TO HER/HIS INSTAGRAM ACCOUNT</div>
                      </div>
                    }
                  </div>
                )}
              )}
            </div>
            <div className={css(styles.exploreRow2)}>
              {users2.map((user, i) => {
                var linkToInstagram;
                for(var j=0; j<user.socials.length; j++){
                  if(user.socials[j].type === "instagram"){
                    linkToInstagram = user.socials[j].link;
                  } 
                }
                var minimaaLinkInBio = -1;
                if(user.instagram_user){
                  if(user.instagram_user.website){
                    minimaaLinkInBio = user.instagram_user.website.search("minimaa");
                  }
                }
                var avgLikes = 0;
                var avgComments = 0;
                var usingHashtags = 0;
                var usingLocation = 0;
                var usingFilters = 0;
                var taggingUsers = 0;

                if(user.media){
                  if(user.media.data){
                    for(i=0; i<user.media.data.length; i++){
                      avgLikes = avgLikes+user.media.data[i].likes.count;
                      avgComments = avgComments+user.media.data[i].comments.count;
                      if(user.media.data[i].tags.length > 0){
                        usingHashtags++;
                      }
                      if(user.media.data[i].location){
                        usingLocation++;
                      }
                      if(user.media.data[i].filter !== "Normal"){
                        usingFilters++;
                      }
                      if(user.media.data[i].users_in_photo.length > 0){
                        taggingUsers++;
                      }
                    }
                    avgLikes = Math.round(avgLikes/user.media.data.length);
                    avgComments = Math.round(avgComments/user.media.data.length);
                    usingHashtags = Math.round(usingHashtags*100/user.media.data.length);
                    usingLocation = Math.round(usingLocation*100/user.media.data.length);
                    usingFilters = Math.round(usingFilters*100/user.media.data.length);
                    taggingUsers = Math.round(taggingUsers*100/user.media.data.length);
                  }
                }
                return (
                  <div key={user.id} className={css(styles.exploreWrapper)}>
                    {user.instagram_user ?
                      <h4 className={css(styles.red)}>{user.website_title}</h4>
                      :
                      <h4 >{user.website_title}</h4>
                    }
                    <div className={css(styles.exploreInnerWrapper)}>
                      <img className={css(styles.exploreImg)} alt="" src={user.profile_picture}/>
                      <div className={css(styles.explereOverlay)}>
                        <p>{user.description}</p>
                        <a rel="noopener noreferrer" target="_blank" href={"https://"+user.subdomain+".minimaa.co"} className={css(styles.button5)}>
                          VISIT WEBSITE
                        </a>
                        <a rel="noopener noreferrer" target="_blank" href={linkToInstagram}>
                          <img alt="instagram" className={css(styles.explereOverlayInstagram)}src="../../assets/instagram.png" />
                        </a>
                      </div>
                    </div>
                     <div className={css(styles.infoBox)}>
                      <div>Categories({user.hashtags.length}):</div>
                      <div>Links({user.socials.length}):</div>
                      <div>Minimaa link in bio: {minimaaLinkInBio === -1 ? "NO" : "YES"}</div>
                      <div>Avarage likes per post: {avgLikes}</div>
                      <div>Avarage comments per post: {avgComments}</div>
                      {user.instagram_user && <div>media: {user.instagram_user.counts.media}</div>}
                      {user.instagram_user && <div>followers: {user.instagram_user.counts.followed_by}</div>}
                      {user.instagram_user && <div>following: {user.instagram_user.counts.follows}</div>}
                      <div>usingHashtags: {usingHashtags}% of posts</div>
                      <div>usingLocation: {usingLocation}% of posts</div>
                      <div>usingFilters: {usingFilters}% of posts</div>
                      <div>taggingUsers: {taggingUsers}% of posts</div>
                    </div>
                  </div>
                )}
              )}
            </div>
          </div>
          <div className={css(styles.section12explore1)}>
            {users.map((user, i) => {
              var linkToInstagram;
                for(var j=0; j<user.socials.length; j++){
                  if(user.socials[j].type === "instagram"){
                    linkToInstagram = user.socials[j].link;
                  } 
                }
                var minimaaLinkInBio = -1;
                if(user.instagram_user){
                  if(user.instagram_user.website){
                    minimaaLinkInBio = user.instagram_user.website.search("minimaa");
                  }
                }
                var avgLikes = 0;
                var avgComments = 0;
                var usingHashtags = 0;
                var usingLocation = 0;
                var usingFilters = 0;
                if(user.media){
                  if(user.media.data){
                    for(i=0; i<user.media.data.length; i++){
                      avgLikes = avgLikes+user.media.data[i].likes.count;
                      avgComments = avgComments+user.media.data[i].comments.count;
                      if(user.media.data[i].tags.length > 0){
                        usingHashtags++;
                      }
                      if(user.media.data[i].location){
                        usingLocation++;
                      }
                      if(user.media.data[i].filter !== "Normal"){
                        usingFilters++;
                      }
                    }
                    avgLikes = Math.round(avgLikes/user.media.data.length);
                    avgComments = Math.round(avgComments/user.media.data.length);
                    usingHashtags = Math.round(usingHashtags*100/user.media.data.length);
                    usingLocation = Math.round(usingLocation*100/user.media.data.length);
                    usingFilters = Math.round(usingFilters*100/user.media.data.length);
                  }
                }
                return (
                  <div key={user.id} className={css(styles.exploreWrapper)}>
                    <h4>{user.website_title}</h4>
                    <div className={css(styles.exploreInnerWrapper)}>
                      <img className={css(styles.exploreImg)} alt="" src={user.profile_picture}/>
                      <div className={css(styles.explereOverlay)}>
                        <p>{user.description}</p>
                        <a rel="noopener noreferrer" target="_blank" href={"https://"+user.subdomain+".minimaa.co"} className={css(styles.button5)}>
                          VISIT WEBSITE
                        </a>
                        <a rel="noopener noreferrer" target="_blank" href={linkToInstagram}>
                          <img alt="instagram" className={css(styles.explereOverlayInstagram)}src="../../assets/instagram.png" />
                        </a>
                      </div>
                    </div>
                    <div className={css(styles.infoBox)}>
                      <div>Categories({user.hashtags.length}):</div>
                      <div>Links({user.socials.length}):</div>
                      <div>Minimaa link in bio: {minimaaLinkInBio === -1 ? "NO" : "YES"}</div>
                      <div>Avarage likes per post: {avgLikes}</div>
                      <div>Avarage comments per post: {avgComments}</div>
                      {user.instagram_user && <div>media: {user.instagram_user.counts.media}</div>}
                      {user.instagram_user && <div>followers: {user.instagram_user.counts.followed_by}</div>}
                      {user.instagram_user && <div>following: {user.instagram_user.counts.follows}</div>}
                      <div>usingHashtags: {usingHashtags}% of posts</div>
                      <div>usingLocation: {usingLocation}% of posts</div>
                      <div>usingFilters: {usingFilters}% of posts</div>
                    </div>
                  </div>
                )}
              )}
          </div>
        </div>
        {this.props.hasNextPage &&
          <div className={css(styles.sectionLoadMore)}>
            <div className={css(styles.section11)}>
            </div>
            <div className={css(styles.section12LoadMore)}>
              <div className={css(styles.button)} onClick={this.props.onLoadMore}>LOAD MORE</div>
            </div>
          </div>
        }
      </React.Fragment>

    );
  }
}

const styles = StyleSheet.create({
  infoBox:{
    fontSize:14,
  },

  red:{
    color:"red",
  },

  wrapper:{
    width:"calc(100vw - 240px)",
    margin:"0 auto",
    maxWidth:1150,

    '@media (max-width: 1300px)': {
      width:"calc(100% - 130px)",
    },
    '@media (max-width: 1150px)': {
      width:"100%",
    },
  },
  wrapperBackground:{
    width:"100%",
    color:"#fff",
    position:"relative",
    // backgroundSize: "cover",
    // backgroundPosition:"70% 60%",
    // '@media (max-width: 560px)': {
    //   height:"auto",
    //   minHeight:"100vh",
    //   backgroundPosition:"40% 60%",
    //   backgroundSize: "100vh",
    //   backgroundRepeat: "no-repeat",
    // },
  },
  innerWrapper:{
    position:"absolute",
    top:0,
    left:100,
    display:"flex",
    flexDirection:"column",
    justifyContent: 'center',
    alignItems:"flex-start",
    bottom:0,
    margin:"0 auto",
    width:"calc(100% - 200px)",
    '@media (max-width: 1400px)': {
      width:"calc(100% - 140px)",
      left:70,
    },
    '@media (max-width: 950px)': {
      width:"calc(100% - 80px)",
      left:40,
    },
    '@media (max-width: 560px)': {
      width:"calc(100% - 80px)",
      left:40,
    },
    '@media (max-width: 340px)': {
      width:"calc(100% - 50px)",
      left:25,
    },
  },
  backgroundImg:{
    width:"100%",
    minHeight:600,
    objectFit:"cover",
    objectPosition: "0% 5%",
    maxHeight:700,
    background:"#9c9899",
    '@media (max-width: 800px)': {
      objectFit:"cover",
      minHeight:460,
    },
    '@media (max-width: 470px)': {
      objectPosition: "20% 0%",
    },
  },
  gradient:{
    background: "linear-gradient(89.79deg, rgba(40, 39, 44, 0.9) 0.11%, rgba(40, 39, 44, 0) 50%)",
    position:"absolute",
    width:"100%",
    top:0,
    bottom:4,
    left:0,
    right:0,
    '@media (max-width: 470px)': {
      background: "linear-gradient(100.3deg, #28272C 9.49%, rgba(40, 39, 44, 0) 63.84%)",
    }
  },
  heroFootnote:{
    marginTop:24,
    fontSize:12,
    lineHeight: "18px",
    letterSpacing: "0.136364px",
    '@media (max-width: 470px)': {
      display:"none",
    },
  },
  heroFootnoteAbsolute:{
    bottom:15,
    fontSize:12,
    position:"absolute",
    lineHeight: "18px",
    letterSpacing: "0.136364px",
    left:20,
    width:"calc(100% - 40px)",
    textAlign:"center",
    '@media (min-width: 470px)': {
      display:"none",
    },
    '@media (max-width: 360px)': {
      fontSize:10,
      width:"calc(100% - 30px)",
      left:15,
    },
  },
 


  h1Warpper:{
    marginBottom:29,
    maxWidth:550,
    '@media (max-width: 1550px)': {
      maxWidth:500,
    },
    '@media (max-width: 800px)': {
      maxWidth:450,
      marginBottom:20,
    },
    '@media (max-width: 560px)': {
      maxWidth:250,
      marginBottom:17,
    },
    '@media (max-width: 380px)': {
      maxWidth:300,
    },
  },
  h2Warpper:{
    marginBottom:50,
    maxWidth:420,
    '@media (max-width: 800px)': {
      maxWidth:350,
      marginBottom:30,
    },
    '@media (max-width: 560px)': {
      display:"none",
    },
  },
  h2WarpperMobile:{
    marginBottom:40,
    maxWidth:185,
    '@media (min-width: 561px)': {
      display:"none",
    },
  },








  sectionLoadMore:{
    display:"flex",
    width:"calc(100% - 200px)",
    justifyContent:"space-between",
    margin:"150px auto",
    marginTop:-50,
    '@media (max-width: 1400px)': {
      width:"calc(100% - 140px)",
    },
    '@media (max-width: 1020px)': {
      flexDirection:"column",
      alignItems:"center",
      paddingTop:0,
    },
    '@media (max-width: 800px)': {
      margin:"40px auto",
    },
    '@media (max-width: 950px)': {
      width:"calc(100% - 80px)",
    },
    '@media (max-width: 560px)': {
      width:"calc(100% - 80px)",
    },
    '@media (max-width: 420px)': {
      alignItems:"flex-start",
    },
    '@media (max-width: 340px)': {
      width:"calc(100% - 50px)",
    }
  },
  section:{
    display:"flex",
    width:"calc(100% - 200px)",
    justifyContent:"space-between",
    margin:"150px auto",
    marginTop:50,
    paddingTop:50,
    '@media (max-width: 1400px)': {
      width:"calc(100% - 140px)",
    },
    '@media (max-width: 1020px)': {
      flexDirection:"column",
      alignItems:"center",
      paddingTop:0,
    },
    '@media (max-width: 800px)': {
      margin:"40px auto",
      marginTop:50,
    },
    '@media (max-width: 950px)': {
      width:"calc(100% - 80px)",
    },
    '@media (max-width: 560px)': {
      width:"calc(100% - 80px)",
    },
    '@media (max-width: 420px)': {
      alignItems:"flex-start",
    },
    '@media (max-width: 340px)': {
      width:"calc(100% - 50px)",
    }
  },
  section11:{
    width:270,
    minWidth:270,
    '@media (max-width: 1020px)': {
      textAlign:"center",
    },
    '@media (max-width: 420px)': {
      textAlign:"left",
    },
  },
  buttonWrapper:{
    marginTop:45,
  },
  h4Wrapper:{
    marginBottom:20,
    '@media (max-width: 420px)': {
      maxWidth:270,
    },
  },
  button:{
    border:"none",
    letterSpacing: "0.163636px",
    position:"relative",
    background:"#3A80E4",
    color:"#fff",
    textDecoration:"none",
    padding:"9px 22px 9px 22px",
    cursor:"pointer",
    outline:"none",
    borderRadius:"25px",
    fontSize:12,
    lineHeight:"14px",
    fontWeight:500,
    transition:"0.3s",
    ":hover":{
      background:"#266CD0",
    },
    '@media (max-width: 420px)': {
      fontSize:14,
    }
  },
  
  button4:{
    position:"absolute",
    bottom:80,
    letterSpacing: "0.163636px",
    right:100,
    display:"flex",
    border:"2px solid transparent",
    background:"transparent",
    // cursor:"pointer",
    zIndex:1,
    alignItems:"center",
    color:"#fff",
    textDecoration:"none",
    lineHeight:"14px",
    justifyContent: 'space-between',
    padding:"9px 16px 9px 16px",
    outline:"none",
    borderRadius:"25px",
    fontSize:12,
    fontWeight:500,
    transition:"0.2s",
    '@media (max-width: 1550px)': {
      right:70,
      bottom:50,
    },
    '@media (max-width: 950px)': {
      right:20,
      bottom:40,
    },
    '@media (max-width: 420px)': {
      fontSize:14,
    }
  },
  button5:{
    position:"relative",
    border:"2px solid #fff",
    background:"transparent",
    alignItems:"center",
    color:"#fff",
    letterSpacing: "0.163636px",
    textDecoration:"none",
    justifyContent: 'space-between',
    padding:"10px 20px 9px 20px",
    cursor:"pointer",
    outline:"none",
    borderRadius:"25px",
    fontSize:12,
    fontWeight:500,
    marginTop:30,
    transition:"0.3s",
    ":hover":{
      color:"#000",
      background:"#fff",
    },
    '@media (max-width: 420px)': {
      fontSize:14,
    }
  },
  section12:{
    display:"flex",
    flexWrap:"wrap",
    justifyContent:"flex-end",
    '@media (max-width: 1020px)': {
      width:540,
      justifyContent:"space-between",
    },
    '@media (max-width: 800px)': {
      justifyContent:"space-between",
    },
    '@media (max-width: 600px)': {
      flexDirection:"column",
      marginTop:20,
      width:240,
    },
    '@media (max-width: 420px)': {
      width:"100%",
      maxWidth:320,
    }
  },
  section11Pricing:{
    width:270,
    minWidth:270,
    display:"flex",
    flexDirection:"column",
    justifyContent:"space-between",
    alignItems:"flex-start",
    '@media (max-width: 1020px)': {
      textAlign:"center",
    },
    '@media (max-width: 420px)': {
      textAlign:"left",
    },
  },
  section11Pricing1:{

  },
  section11Pricing2:{
    opacity:0.4,
    color:"#000",
    transition:"0.2s",
    marginTop:40,
    width:240,
    cursor:"default",
    textDecoration:"none",
    display:"block",
    '@media (max-width: 1020px)': {
      display:"none",
    },
    ":hover":{
      opacity:1,
    }
  },
  section11Pricing22:{
    opacity:0.4,
    color:"#000",
    transition:"0.2s",
    marginTop:80,
    width:240,
    cursor:"default",
    textDecoration:"none",
    display:"block",
    textAlign:"center",
    '@media (min-width: 1021px)': {
      display:"none",
    },
    '@media (max-width: 420px)': {
      textAlign:"left",
      width:270,
    },
    ":hover":{
      opacity:1,
    }
  },
  getInstagramTitle:{
    fontSize:16,
  },
  getInstagramText:{
    marginTop:15,
    fontSize:14,
  },
  getInstagramLink:{
    marginTop:30,
    fontSize:16,
    fontWeight:500,
    cursor:"pointer",
  },
  getInstagramLinkImg:{
    transform:"rotate(270deg)",
    width:20,
    marginBottom:-4,
    marginLeft:10,
  },
  section12pricing:{
    display:"flex",
    width:"100%",
    maxWidth:800,
    justifyContent:"flex-end",
    '@media (max-width: 1020px)': {
      justifyContent:"center",
    },
    '@media (max-width: 420px)': {
      justifyContent:"flex-start",
    },
    
  },
  showcaseImgWrapper:{
    maxWidth:540,
    '@media (max-width: 1020px)': {
      display:"none",
    },
  },
  showcaseMobileWrapper:{
    margin:"0 auto",
    display:"flex",
    justifyContent:"flex-start",
    alignItems:"center",
    flexDirection:"column",
    '@media (min-width: 1021px)': {
      display:"none",
    },
    marginTop:80,
    width:"100%",
  },
  showcaseImgMobile:{
    height:500,
    transition:"0.2s ease-in-out",
    '@media (max-width: 770px)': {
      height:400,
    },
    '@media (max-width: 550px)': {
      height:300,
    },
    '@media (max-width: 410px)': {
      height:270,
    },
    '@media (max-width: 360px)': {
      height:240,
    },
  },
  showcaseImgMobileMobile:{
    height:500,
    transition:"0.2s ease-in-out",
    '@media (max-width: 770px)': {
      height:400,
    },
    '@media (max-width: 550px)': {
      height:300,
    },
    '@media (max-width: 410px)': {
      height:270,
    },
    '@media (max-width: 360px)': {
      height:240,
    },
  },
  showcaseToggle:{
    width:"100%",
    display:"flex",
    cursor:"pointer",
    justifyContent:"center",
    alignItems:"center",
    overflow:"hidden",
    background: "#FFFFFF",
    boxShadow: "0px 10px 30px rgba(21, 23, 54, 0.1)",
    borderRadius: 30,
    height:40,
  },
  showcaseToggleButtonOn:{
    width:"50%",
    userSelect: "none",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    background:"#000",
    color:"#fff",
    height:40,
    transition:"0.2s ease-in-out",
  },
  showcaseToggleButtonOff:{
    width:"50%",
    userSelect: "none",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    height:40,
    transition:"0.2s ease-in-out",
  },
  showcaseImg:{
    width:"100%",
  },
  howWrapper:{
    width:"100%",
    marginBottom:80,
    marginLeft:60,
    maxWidth:240,
    '@media (max-width: 1020px)': {
      marginLeft:0,
      marginRight:0,
      maxWidth:240,
      marginTop:80,
      marginBottom:0,
    },
    '@media (max-width: 420px)': {
      maxWidth:320,
    },
  },
  howIcon:{
    height:60,
    marginBottom:30,
    '@media (max-width: 1020px)': {
      marginLeft:85,
    },
    '@media (max-width: 420px)': {
      marginLeft:0,
      height:80,
    },
  },

  exploreInnerWrapper:{
    position:"relative",
    marginTop:10,
  },
  exploreWrapper:{
    width:"100%",
    marginBottom:80,
    maxWidth:240,
    '@media (max-width: 1020px)': {
      marginLeft:0,
      marginRight:0,
      maxWidth:240,
      marginTop:80,
      marginBottom:0,
    },
    '@media (max-width: 420px)': {
      maxWidth:320,
    },
  },
  exploreImg:{
    width:"100%",
    minHeight:200,
  },
  section12explore:{
    display:"flex",
    justifyContent:"space-between",
    '@media (max-width: 620px)': {
      display:"none",
    },
  },
  section12LoadMore:{
    display:"flex",
    width:"100%",
    marginLeft:140,
    justifyContent:"flex-start",
  },
  section12exploreLoading:{
    display:"flex",
    marginTop:50,
    justifyContent:"center",
  },
  section12explore1:{
    display:"none",
    '@media (max-width: 620px)': {
      display:"block",
    },
  },
  exploreRow1:{
    maxWidth:240,
    width:240,
    marginLeft:100,
    '@media (max-width: 1550px)': {
      marginLeft:60,
    },
    '@media (max-width: 1020px)': {
      marginLeft:0,
    },
  },
  exploreRow2:{
    maxWidth:240,
    width:240,
    marginLeft:100,
    '@media (max-width: 1550px)': {
      marginLeft:60,
    },
  },
  explereOverlayInstagram:{
    position:"absolute",
    filter:"invert(1)",
    bottom:5,
    right:5,
    width:35,
  },

  explereOverlay:{
    position:"absolute",
    background:"rgba(0,0,0,0.35)",
    color:"#fff",
    padding:30,
    textAlign:"center",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    flexDirection:"column",
    top:0,
    left:0,
    bottom:2,
    // borderRadius:20,
    // transform:"scale(0.9)",
    right:0,
    opacity:0,
    transition:"0.2s ease-in-out 0.3s",
    ":hover":{
      opacity:1,
      transition:"0.2s ease-in-out",
      // borderRadius:0,
      // transform:"scale(1)",
    },
  },




  pricingWrapper:{
    width:"100%",
    marginBottom:0,
    marginRight:300,
    maxWidth:240,
    boxShadow: "0px 30px 30px rgba(21, 23, 54, 0.1)",
    
    '@media (max-width: 1020px)': {
      marginLeft:0,
      marginRight:0,
      maxWidth:240,
      marginTop:80,
      marginBottom:0,
    },
    '@media (max-width: 420px)': {
      maxWidth:340,
    }
  
  },
  pricingSuggested:{
    width: "100%",
    color:"#fff",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    height: 30,
    fontSize: 12,
    background: "#000",
  },
  pricing:{
    padding:"50px 20px",
    textAlign:"center",
  },
  pricingTitle:{
    fontSize: 18,
    fontWeight:600,
  },
  pricingFreeTrial:{
    marginTop:12,
    fontSize: 15,
  },
  pricingPrice:{
    fontSize:48,
    marginTop:40,
  },
  pricingPricingFrequency:{
    color:"#A3A3A3",
    marginTop:35,
    fontSize: 14,
  },
  pricingCaption:{
    fontSize: 12,
    marginTop:40,
    lineHeight:1.3,
    '@media (max-width: 420px)': {
      maxWidth:210,
      fontSize: "14px",
      margin:"0 auto",
      marginTop:40,
      lineHeight: "21px",
      letterSpacing: "0.136364px",
    }
  },
  pricingButton:{
    display:"block",
    maxWidth:80,
    margin:"0 auto",
    marginTop:45,
    position:"relative",
    border:"2px solid #000",
    background:"#000",
    color:"#fff",
    textDecoration:"none",
    padding:"9px 16px 9px 19px",
    cursor:"pointer",
    outline:"none",
    borderRadius:"25px",
    lineHeight:"14px",
    fontSize:12,
    fontWeight:500,
    transition:"0.3s",
    ":hover":{
      color:"#000",
      background:"transparent",
    },
    '@media (max-width: 420px)': {
      fontSize:14,
      maxWidth:90,
    }
  },

  subtitle2:{
    fontSize:14,
    lineHeight:"21px",
    fontWeight:500,
  },

});

export default ExplorePage;
